<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>
<script>
import QRCode from 'qrcode'; 
export default {
  name: "QrCode",
  props: ['value'],
  watch: {
    value: function (n) {
      if (n) this.generateCode(n)
    }
  },
  mounted() {
    this.generateCode(this.value);
  },
  methods: {
    generateCode(data) {
      if (!data) return;
      console.log('generateCode', data)
      if (typeof data !== 'string') data = JSON.stringify(data);
      return new Promise((resolve, reject) => {
        QRCode.toCanvas(this.$refs.canvas, data, function (error) {
          if (error) {
            return reject(error)
          }
          return resolve()
        })
      })
    }
  },
}
</script>